var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 824 232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f2fce;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.51,214.59L8.75,17.15h58.12l-1.59,140.12-.8,10.88h.8l3.72-10.88L127.11,17.15h59.71l-93.15,197.44H17.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.14,219.1c-25.83,0-44.58-7.08-56.26-21.23-11.68-14.15-14.51-35.56-8.49-64.22l7.7-35.56c6.19-28.48,17.07-49.8,32.64-63.96,15.57-14.15,36.45-21.23,62.63-21.23s45.42,7.25,56.66,21.76c11.23,14.51,13.76,35.91,7.56,64.22l-7.43,34.5c-6.19,28.66-16.98,50.11-32.38,64.35-15.39,14.24-36.27,21.36-62.63,21.36ZM225.3,171.33c7.25,0,13.31-2.34,18.18-7.03,4.87-4.69,8.54-12.87,11.01-24.55l10.08-46.97c2.48-12.03,2.21-20.39-.8-25.08s-8.14-7.03-15.39-7.03-13,2.34-17.78,7.03-8.4,12.78-10.88,24.28l-10.35,47.77c-2.3,11.68-1.86,19.86,1.33,24.55,3.18,4.69,8.05,7.03,14.6,7.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.3,214.59h-62.9l63.96-101.38-17.78-96.07h60.51l5.31,59.98.8,12.21h.8l6.1-12.21,30.25-59.98h62.63l-58.65,95.8,20.7,101.64h-60.77l-7.96-65.02-1.06-12.74h-.53l-6.63,13-34.76,64.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509,214.59h-62.9l63.96-101.38-17.78-96.07h60.51l5.31,59.98.8,12.21h.8l6.1-12.21,30.25-59.98h62.63l-58.65,95.8,20.7,101.64h-60.77l-7.96-65.02-1.06-12.74h-.53l-6.63,13-34.76,64.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.85,214.59h-57.32l11.68-54.14-25.21-143.31h59.71l5.04,79.08-.27,10.08h.53l3.72-10.08,36.62-79.08h62.9l-85.98,143.31-11.41,54.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/HEADER.269e98001eb4ba485490c98a345fd68a.svg";
export { ForwardRef as ReactComponent };